<template>
    <CModal
      :color="color"
      :show.sync="showModal"
      size="lg"
      class="basic-modal-color"
    >   
    <template #header>
      <CRow style="width: 100%; height: 35px;">
        <CCol md="9">
          <h5 class="modal-title">{{title}}</h5>
        </CCol>
        <CCol md="3">
          
        </CCol>
      </CRow>
      <CButtonClose @click="showModal = false"/>            
    </template>
      <CRow>      
        <CCol md="12">
          <CButton class="crema" size="sm" @click="selectAll()">Seleccionar Todos</CButton>
          <br /><br />
          <CDataTable
            :hover="hover"
            :striped="striped"
            :border="border"
            :small="small"
            :fixed="fixed"
            :items="guests"
            :fields="fields"
            :dark="dark"
          >         
            <template #position="{item}">
              <td class="text-center w80">
                <input type="checkbox" v-model="idsGuests" @change="checkGuests(item)" :value="item.id" :id="'check-'+item.id">
              </td>
            </template>
            <template #name="{item}"><td class="text-left" style="font-size: 12px;"><b style="font-size: 12px;">{{item.name}}</b></td></template>
            <template #last_name="{item}"><td class="text-left" style="font-size: 12px;"><b style="font-size: 12px;">{{item.last_name}}</b></td></template>
            <template #nickname="{item}"><td class="text-center w150" style="font-size: 12px;">{{item.nickname}}</td></template>
            <template #phone="{item}"><td class="text-center w100" style="font-size: 12px;">{{item.phone}}</td></template>
            <template #email="{item}">
              <td class="text-center w200" style="font-size: 12px;">
                <template v-if="item.email != ''">
                  {{item.email}}
                </template>
                <template v-else>
                  -
                </template>                  
              </td>
            </template>
            <template #tickets="{item}"><td class="text-center w100" style="font-size: 12px;">{{item.tickets}}</td></template>
            <template #table="{item}">
              <td class="text-center w100" style="font-size: 12px;">
                <template v-if="item.table != ''">
                  {{item.table}}
                </template>
                <template v-else>
                  -
                </template>                
              </td>
            </template>
            <template #confirm_date="{item}">
              <td class="text-center w100">
                <template v-if="item.is_confirm != ''">
                  {{item.confirm_date | date}}                  
                </template>                
              </td>
            </template>       
            <template #confirm_method="{item}">
              <td class="text-center w100" style="font-size: 16px;">
                <template v-if="item.confirm_method == 'admin'">
                  Administrador
                </template>
                <template v-else-if="item.confirm_method == 'whats'">
                  Whatsapp
                </template>
                <template v-else-if="item.confirm_method == 'email'">
                  Correo Electronico
                </template>
                <template v-else>
                  -
                </template>
              </td>
            </template>                 
            <template #is_confirm="{item}">
              <td class="text-center w100" style="font-size: 16px;">
                <template v-if="item.is_confirm == 0">
                  <CBadge color="warning">Pendiente</CBadge>
                </template>
                <template v-else-if="item.is_confirm == 2">
                  <CBadge color="danger">No</CBadge>
                </template>
                <template v-else>
                  <CBadge color="success">Si</CBadge>
                </template>          
              </td>
            </template>
            <template #actions="{item}">
              <td style="padding: 0px; padding-bottom: 2px;" class="table_actions w150 text-center">                
              </td>
            </template>
          </CDataTable>        
        </CCol>              
      </CRow>      
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="sendTickets('email')" :color="color">Enviar Boletos</CButton>
        </template>
    </CModal>
</template>

<script>
import store from '@/store';
import ws from '@/services/events_guests';

export default {
  name: 'SendMasiveTicketsModal',
  props: {
    fields: {
      type: Array,
      default () {
        return [
          {key: 'position', label: 'N°' ,_style:"font-size: 12px;"},
          {key: 'name', label: 'Nombre',_style:"font-size: 12px;"},
          {key: 'last_name', label: 'Apellido',_style:"font-size: 12px;"},
          {key: 'nickname', label: 'Apodo',_style:"font-size: 12px;"},
          {key: 'phone', label: 'Whatsapp',_style:"font-size: 12px;"},
          {key: 'email', label: 'Email',_style:"font-size: 12px;"},
          {key: 'tickets', label: 'Invitados',_style:"font-size: 12px;"},
          {key: 'table', label: 'Mesa',_style:"font-size: 12px;"},
          {key: 'is_confirm', label: 'Confirmación',_style:"font-size: 12px;"},
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  components: {
  },
  data () {
    return {
      showModal: false,
      title: "Enviar Boletos",
      color: "info",
      submitted: false,      
      guests: [],      
      idsGuests:[],
      statusCheckAll: false,
      event: false
    }
  },
  mounted: async function() {    
    
  },
  methods: {
    async showSendModal (event_id, event) {
      this.event = event;

      this.loading();
        this.showModal = true;
        this.color = "info";
        this.title = 'Enviar Boletos';
        this.isEdit = false;
        this.submitted = false;

        this.guests = [];
        this.idsGuests = [];
        this.statusCheckAll = false;

        let filters = {
          event_id: event_id,
          // is_confirm: 0,
        };
      
        let response = await ws.get(filters);
        if(response.type == "success"){
          this.guests = response.data;

          this.guests.forEach(function callback(guest) {
              guest.checkbox = false;
          });
        }
      this.loaded();

    },
    async sendTickets (type) {
      this.loading();

      let invitations = this.idsGuests;

      if(invitations.length > 0){
        let response = await ws.sendMasiveTickets({data: invitations, sender: type});

        this.closeModal();
        
        if(response.type == "success"){
          this.showToast("success", "Las notificaciones para los invitados han sido enviadas correctamente.");
        }
        else{
          this.showToast("error", response.message);
        }
        
      }
      else{
        this.showToast("error", "Debes seleccionar al menos un invitado para enviar las notificaciones.");
      }

      this.loaded();          
    },
    checkGuests: function(element){            
      let idx = this.idsGuests.findIndex(c => c.id == element.id);     
      if(idx != -1){
        this.idsGuests.splice(idx, 1);                
        this.statusCheckAll = false;      
      }
    },
    selectAll () {
      if(!this.idsGuests.length > 0){
        this.statusCheckAll = false;  
      }
      this.idsGuests = [];            
      this.statusCheckAll = !this.statusCheckAll
      if(this.statusCheckAll){
        this.guests.forEach(element => {
          this.idsGuests.push(element.id) ;
        });
      }
    },
    closeModal () {
      this.showModal = false;

      this.guests.forEach(function callback(guest) {
          guest.checkbox = false;
      });

      this.submitted = false
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
}
</script>
<style>
.basic-modal-color .modal-header{
  background-color: #668269 !important;
}
.crema{
  background-color: #F4F0E5;
  color: black;
}
</style>